import React, { useState, useEffect } from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { Section } from 'bloomer/lib/layout/Section';
import { Title } from 'bloomer/lib/elements/Title';
import RichTextEditor from 'react-rte';
import { Content } from 'bloomer/lib/elements/Content';
import { Button } from 'bloomer/lib/elements/Button';
import Conditional from '../components/Conditional';
import LoadingSpinner from '../elements/LoadingSpinner';
import api from '../util/api';
import { popupErrorFromServer, successAlert } from '../util/helperFunctions';

interface PropTypes {
  path: string;
}

// RichTextEditor.createValueFromString(markup, 'html')
export const CustomContentAdminOptions = (props: PropTypes) => {
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());
  const [isLoading, setIsLoading] = useState(true);

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await api.customContent.patch('patio_rules', {
        content: editorState.toString('html'),
      });
      await refresh();
      successAlert(`Patio rules updated successfully!`);
    } catch (err) {
      popupErrorFromServer(err);
    }
  };

  const refresh = async () => {
    try {
      setIsLoading(true);
      const { content } = await api.customContent.getOne('patio_rules');
      if (content) {
        setEditorState(RichTextEditor.createValueFromString(content, 'html'));
      }
      setIsLoading(false);
    } catch (err) {
      popupErrorFromServer(err);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <Container>
      <Box>
        <Section>
          <Title tag="h2" isSize={4}>
            Patio Rules:
          </Title>
        </Section>
        <Conditional alt={<LoadingSpinner />} check={!isLoading}>
          <>
            <Content>
              <RichTextEditor value={editorState} onChange={setEditorState} />
            </Content>
            <Button isColor="primary" onClick={handleSubmit}>
              Save
            </Button>
          </>
        </Conditional>
      </Box>
    </Container>
  );
};

export default CustomContentAdminOptions;
